import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import "./scss/theme.scss";
import axios from "axios";

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//TODO use tree shaking alternative for performance!
library.add(fas)

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

Vue.use(BootstrapVue);
Vue.use(VueCompositionAPI);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
